import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LemApp1 from './LemApp1'
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
// <React.StrictMode> will make use_effect()[] run twice, it confuses
root.render(
    <LemApp1 />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
